//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as Actions from "./actions";
import { logToSentry } from "utils/networkErrorUtils";
import { has } from "lodash";

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- List chapter interactions ------

export const handleListOneWayTeacherVideo = () => async (dispatch) => {
  try {
    const video = await apis.get("oneway_teacher_video", `/list`);
    if (Array.isArray(video)) {
      await dispatch(Actions.listOnewayTeacherVideo(video));
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'listing one way teacher video',
                error,
                module: 'ONE_WAY_TEACHER_VIDEO',
                operation: 'LIST_ORGANIZATION_WORD_TEACHER_VIDEO'
            });
    }
  }
};

export const handleCreateHOneWayTeacherVideo = (data) => async (dispatch) => {
  try {
    const videos = await apis.post("oneway_teacher_video", `/create`, {
      body: data,
    });
    if (has(videos, "id")) {
      await dispatch(Actions.createOnewayTeacherVideo(videos));
    }
    return videos;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'creating one way teacher video',
                error,
                module: 'ONE_WAY_TEACHER_VIDEO',
                operation: 'CREATE_ORGANIZATION_WORD_TEACHER_VIDEO'
            })
    }
  }
};
export const handleUpdateOneWayTeacherVideo = (data) => async (dispatch) => {
  try {
    const videos = await apis.put("oneway_teacher_video", `/update`, {
      body: data,
    });
    if (has(videos, "id")) {
      await dispatch(Actions.updateOnewayTeacherVideo(videos));
    }
    return videos;
  } catch (error) {
    if (error && error.message != "Network Error") {
       logToSentry({
                message: 'updating one way teacher video',
                error,
                module: 'ONE_WAY_TEACHER_VIDEO',
                operation: 'UPDATE_ORGANIZATION_WORD_TEACHER_VIDEO'
            })
    }
    console.log(error, "error");
  }
};
export const handleDeleteOnewayTeacherVideo = (id) => async (dispatch) => {
  try {
    const videos = await apis.del("oneway_teacher_video", `/delete/${id}`);
    if (has(videos, "id")) {
      await dispatch(Actions.deleteOnewayTeacherVideo(id));
    }
    return videos;
  } catch (error) {
    if (error && error.message != "Network Error") {
     logToSentry({
                message: 'deleting one way teacher video',
                error,
                module: 'ONE_WAY_TEACHER_VIDEO',
                operation: 'DELETE_ORGANIZATION_WORD_TEACHER_VIDEO'
            })
    }
  }
};

export const handleUpdateAllRecord = (data) => async (dispatch) => {
  try {
    const videos = await apis.post("oneway_teacher_video", `/updateAllRecord`, {
      body: data,
    });
    if (Array.isArray(videos)) {
      await dispatch(Actions.listOnewayTeacherVideo(videos));
    }

    return videos;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'ONE_WAY_TEACHER_VIDEO',
                operation: 'LIST_ONE_WAY_TEACHER_VIDEO'
            });
    }
  }
};

export const getCloudflareUploadUrl = async (maxDurationSeconds = 21600, useTus = false, fileName = '', fileSize = 0) => {
  try {
    const response = await apis.post("oneway_teacher_video", `/cloudflare/upload-url`, {
      body: { maxDurationSeconds, requireSignedURLs: false, useTus, fileName, fileSize }
    });
    return response;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'getting cloudflare upload url',
        error,
        module: 'ONE_WAY_TEACHER_VIDEO',
        operation: 'GET_CLOUDFLARE_UPLOAD_URL'
      });
    }
    throw error;
  }
};

export const generateCloudfareCaptions = async (videoId, language = 'es') => {
  try {
    const response = await apis.post("oneway_teacher_video", `/cloudflare/generate-captions`, {
      body: { videoId, language }
    });
    return response;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'generating cloudflare captions',
        error,
        module: 'ONE_WAY_TEACHER_VIDEO',
        operation: 'GENERATE_CLOUDFLARE_CAPTIONS'
      });
    }
    throw error;
  }
};

export const getCloudflareDownloadUrl = async (videoId) => {
  try {
    const response = await apis.post("oneway_teacher_video", `/cloudflare/download-url`, {
      body: { videoId }
    });
    return response;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'getting cloudflare download url',
        error,
        module: 'ONE_WAY_TEACHER_VIDEO',
        operation: 'GET_CLOUDFLARE_DOWNLOAD_URL'
      });
    }
    throw error;
  }
};

